import React from "react";

/**
 * Кастомные SVG-иконки реакций для Блога МИНа (без эмодзи).
 * Filled при активной (цветная заливка), контурные серые при неактивной.
 * Геометрия выверена под 24×24 viewBox.
 */

/* Палец вверх (лайк) */
export function LikeIcon({ active, size = 24 }) {
  const c = active ? "#3357ff" : "#8b94a5";
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path
        d="M7 10.5 11 3c1.3 0 2.3 1 2.3 2.3V9h4.6c1.4 0 2.5 1.3 2.2 2.7l-1.3 6.2c-.2 1.1-1.2 1.9-2.3 1.9H7m0-10.2H4.6c-.6 0-1.1.5-1.1 1.1v8c0 .6.5 1.1 1.1 1.1H7m0-10.2v10.2"
        fill={active ? c : "none"}
        stroke={c}
        strokeWidth="1.7"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/* Сердце (класс) */
export function HeartIcon({ active, size = 24 }) {
  const c = active ? "#ec4899" : "#8b94a5";
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={active ? c : "none"}>
      <path
        d="M12 20.3 4.4 12.6a4.6 4.6 0 0 1 0-6.5 4.6 4.6 0 0 1 6.5 0l1.1 1.1 1.1-1.1a4.6 4.6 0 0 1 6.5 0 4.6 4.6 0 0 1 0 6.5L12 20.3z"
        stroke={c}
        strokeWidth="1.7"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/* Огонь (filled, узнаваемый язык пламени) */
export function FireIcon({ active, size = 24 }) {
  const outer = active ? "#f97316" : "#8b94a5";
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path
        d="M12 2.5c.4 2.6-1 4-2.4 5.5C8.1 9.4 7 10.8 7 13a5 5 0 0 0 10 .3c.1-2.1-.9-3.8-1.8-5-.5.5-1.1.9-1.9 1 .8-2.2.3-4.7-1.3-6.8z"
        fill={active ? outer : "none"}
        stroke={outer}
        strokeWidth="1.7"
        strokeLinejoin="round"
      />
      <path
        d="M12 20a2.7 2.7 0 0 0 2.7-2.7c0-1.4-1.1-2.3-1.7-3-.5.6-1.2 1-1.5 1.8-.5-.4-.8-.9-.9-1.5-.7.7-1.3 1.5-1.3 2.7A2.7 2.7 0 0 0 12 20z"
        fill={active ? "#fde047" : "none"}
        stroke={active ? "#facc15" : outer}
        strokeWidth="1.4"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/* Праздничная хлопушка (party popper) */
export function PartyIcon({ active, size = 24 }) {
  const c = active ? "#8b5cf6" : "#8b94a5";
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      {/* конус */}
      <path
        d="M3 21l4.2-11.3 7.1 7.1L3 21z"
        fill={active ? "#ede9fe" : "none"}
        stroke={c}
        strokeWidth="1.7"
        strokeLinejoin="round"
      />
      {/* линия раскрытия конуса */}
      <path d="M8.4 12.2 6 18.6" stroke={c} strokeWidth="1.3" strokeLinecap="round" />
      {/* конфетти-стримеры */}
      <path d="M14 4.5c1.4-.4 2.3.3 2.6 1.6M17.5 3.2c.3 1.2 1.2 1.8 2.5 1.6M16.4 8.3c1.2.3 2.2-.2 2.7-1.4"
            stroke={c} strokeWidth="1.5" strokeLinecap="round" />
      {/* искры */}
      <circle cx="20.5" cy="9.5" r="0.9" fill={c} />
      <circle cx="13.5" cy="3" r="0.9" fill={c} />
      <circle cx="21.2" cy="13.5" r="0.9" fill={active ? "#c4b5fd" : c} />
    </svg>
  );
}

export const REACTION_ICONS = {
  like: LikeIcon,
  heart: HeartIcon,
  fire: FireIcon,
  party: PartyIcon,
};

export const REACTION_LIST = [
  { id: "like", label: "Нравится" },
  { id: "heart", label: "Класс" },
  { id: "fire", label: "Огонь" },
  { id: "party", label: "Праздник" },
];
